'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _Authorization = require('../../helpers/Authorization');

var _DefaultString = require('../../helpers/DefaultString');

var _ClientError = require('../../helpers/ClientError');

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Logs = require('../../helpers/Logs');

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _AuthorizationExpired = require('./AuthorizationExpired.scss');

var _AuthorizationExpired2 = _interopRequireDefault(_AuthorizationExpired);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrialExpired = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    log: state.log };
}, { startGracePeriod: _auth.startGracePeriod, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TrialExpired, _Component);

  function TrialExpired() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TrialExpired);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TrialExpired.__proto__ || (0, _getPrototypeOf2.default)(TrialExpired)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      provider: null
    }, _this.onAuthorize = function () {
      var path = _Authorization.AuthorizationHelper.authorizeNowPath(_this.state.provider);
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + path));
    }, _this.onAuthorizeLater = function () {
      _this.props.startGracePeriod(_this.props.auth.userInfo.account.operatorId);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TrialExpired, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      (0, _Provider.getProvider)(this.props.auth, function (result) {
        _this2.setState({ provider: result });
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.startingGracePeriod && !nextProps.auth.startingGracePeriod) {
        if (!nextProps.auth.error) {
          (0, _Login2.default)(nextProps.auth.sessionId, nextProps.auth, this.props.log, this.props.appInfo, this.props.pushState, _Logs.LogEventSelectedOptions.Trial);
        } else if (nextProps.auth.userInfo.account.subscription.infinite) {
          (0, _Login2.default)(nextProps.auth.sessionId, nextProps.auth, this.props.log, this.props.appInfo, this.props.pushState, _Logs.LogEventSelectedOptions.Trial);
        } else {
          (0, _ClientError.createLoginClientError)(this.props.auth.error, new Error().stack, this.props.pushState, this.props.auth);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var email = this.props.auth.userInfo ? this.props.auth.userInfo.account.emailAddress : '';
      var canStartGracePeriod = this.props.auth.userInfo && this.props.auth.userInfo.account && this.props.auth.userInfo.account.subscription ? this.props.auth.userInfo.canStartGracePeriod || this.props.auth.userInfo.account.subscription.infinite : false;

      return _react2.default.createElement(
        'div',
        { className: _AuthorizationExpired2.default.authorizationExpired },
        _react2.default.createElement(
          'div',
          { className: _AuthorizationExpired2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.AuthorizationExpiredTitle)
        ),
        _react2.default.createElement(_components.ProviderLogo, { className: _AuthorizationExpired2.default.providerLogo, provider: this.state.provider }),
        _react2.default.createElement(
          'div',
          { className: _AuthorizationExpired2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.AuthorizationExpiredMessage)
        ),
        _react2.default.createElement(_components.BaseButton, { className: _AuthorizationExpired2.default.button, onClick: this.onAuthorize, buttonString: _DefaultString.translations.AuthorizeNow }),
        canStartGracePeriod ? _react2.default.createElement(_components.BaseButton, { className: _AuthorizationExpired2.default.button, onClick: this.onAuthorizeLater, buttonString: _DefaultString.translations.AuthorizationLater }) : '',
        _react2.default.createElement(_components.LogoutButton, { className: _AuthorizationExpired2.default.logout }),
        _react2.default.createElement(
          'div',
          { className: _AuthorizationExpired2.default.email },
          email
        )
      );
    }
  }]);
  return TrialExpired;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  startGracePeriod: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(TrialExpired);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationExpired/AuthorizationExpired.js
// module id = 1996
// module chunks = 0